import { legacyPlugins } from "/builds/sgdf/projets-benevoles/digiform/front/node_modules/.pnpm/@unhead+vue@3.4.3_@oxc-project+types@0.156.0_@vitejs+devtools-kit@0.7.6_@devframes+agen_f7c38f8b94153caaf5659fcca6ba4d23/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}